const MenuChat = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <g clipPath="url(#mobile-menu-chat-clip)">
            <path
                d="M21 12C21 16.3492 16.9703 19.875 12 19.875C11.1086 19.877 10.2208 19.7612 9.35962 19.5308C8.70262 19.8638 7.194 20.5028 4.656 20.919C4.431 20.955 4.26 20.721 4.34888 20.5117C4.74713 19.5712 5.10713 18.318 5.21513 17.175C3.837 15.7913 3 13.98 3 12C3 7.65075 7.02975 4.125 12 4.125C16.9703 4.125 21 7.65075 21 12ZM8.0625 8.625C7.91332 8.625 7.77024 8.68426 7.66475 8.78975C7.55926 8.89524 7.5 9.03832 7.5 9.1875C7.5 9.33668 7.55926 9.47976 7.66475 9.58525C7.77024 9.69074 7.91332 9.75 8.0625 9.75H15.9375C16.0867 9.75 16.2298 9.69074 16.3352 9.58525C16.4407 9.47976 16.5 9.33668 16.5 9.1875C16.5 9.03832 16.4407 8.89524 16.3352 8.78975C16.2298 8.68426 16.0867 8.625 15.9375 8.625H8.0625ZM8.0625 11.4375C7.91332 11.4375 7.77024 11.4968 7.66475 11.6023C7.55926 11.7077 7.5 11.8508 7.5 12C7.5 12.1492 7.55926 12.2923 7.66475 12.3977C7.77024 12.5032 7.91332 12.5625 8.0625 12.5625H15.9375C16.0867 12.5625 16.2298 12.5032 16.3352 12.3977C16.4407 12.2923 16.5 12.1492 16.5 12C16.5 11.8508 16.4407 11.7077 16.3352 11.6023C16.2298 11.4968 16.0867 11.4375 15.9375 11.4375H8.0625ZM8.0625 14.25C7.91332 14.25 7.77024 14.3093 7.66475 14.4148C7.55926 14.5202 7.5 14.6633 7.5 14.8125C7.5 14.9617 7.55926 15.1048 7.66475 15.2102C7.77024 15.3157 7.91332 15.375 8.0625 15.375H12.5625C12.7117 15.375 12.8548 15.3157 12.9602 15.2102C13.0657 15.1048 13.125 14.9617 13.125 14.8125C13.125 14.6633 13.0657 14.5202 12.9602 14.4148C12.8548 14.3093 12.7117 14.25 12.5625 14.25H8.0625Z"
                fill="#534E46"
            />
        </g>
        <defs>
            <clipPath id="mobile-menu-chat-clip">
                <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(3 3)"
                />
            </clipPath>
        </defs>
    </svg>
)

export default MenuChat
